import ehsAtex from './ehs_atex.png';
import ehsEsposizioneARadiazioni from './ehs_esposizione-a-radiazioni.png';
import ehsLavoriACaldo from './ehs_lavori-a-caldo.png';
import ehsLavoriAcquatici from './ehs_lavori-acquatici.png';
import ehsLavoriDiScavo from './ehs_lavori-di-scavo.png';
import ehsLavoriInQuota from './ehs_lavori-in-quota.png';
import ehsLavoroIsolato from './ehs_lavoro-isolato.png';
import ehsLoto from './ehs_loto.png';
import ehsMontaggioImpalcature from './ehs_montaggio-impalcature.png';
import ehsMovimentazioneVeicoli from './ehs_movimentazione-veicoli.png';
import ehsOperazioniDiSollevamento from './ehs_operazioni-di-sollevamento.png';
import ehsOperazioniSuPartiMeccaniche from './ehs_operazioni-su-parti-meccaniche.png';
import ehsSicurezzaElettrica from './ehs_sicurezza-elettrica.png';
import ehsSostanzePericolose from './ehs_sostanze-pericolose.png';
import ehsSpaziConfinati from './ehs_spazi-confinati.png';
import ehsRecuperoFuoriWorkstation from './ehs_recuperoFuoriWorkstation.png';

export const Icons: { [k: string]: any } = {
  atex: ehsAtex,
  esposizioneARadiazioni: ehsEsposizioneARadiazioni,
  lavoriACaldo: ehsLavoriACaldo,
  lavoriAcquatici: ehsLavoriAcquatici,
  lavoriDiScavo: ehsLavoriDiScavo,
  lavoriInQuota: ehsLavoriInQuota,
  lavoroIsolato: ehsLavoroIsolato,
  loto: ehsLoto,
  montaggioImpalcature: ehsMontaggioImpalcature,
  movimentazioneVeicoli: ehsMovimentazioneVeicoli,
  operazioniDiSollevamento: ehsOperazioniDiSollevamento,
  operazioniSuPartiMeccaniche: ehsOperazioniSuPartiMeccaniche,
  sicurezzaElettrica: ehsSicurezzaElettrica,
  sostanzePericolose: ehsSostanzePericolose,
  spaziConfinati: ehsSpaziConfinati,
  recuperoFuoriWorkstation: ehsRecuperoFuoriWorkstation,
};
